module.exports = "<footer>\r\n  <div class=\"pull-right\">\r\n    <strong>{{ versionNumber }}</strong>\r\n  </div>\r\n  <strong>Copyright © {{copyRightYear}}  <a href=\"http://wegocarsharing.com/\" target=\"_blank\"> wegocarsharing.com </a></strong> All rights reserved.\r\n</footer>\n";


//////////////////
// WEBPACK FOOTER
// ./src/app/driver-template/views/driver-footer.component.html
// module id = 629
// module chunks = 0